// constants
import { TestRateCardActionTypes } from './constants';
import { TestRateCard as TestRateCardData } from 'src/types/testRateCard';

export type TestRateCardActionType = {
    type:
        | TestRateCardActionTypes.API_RESPONSE_SUCCESS
        | TestRateCardActionTypes.API_RESPONSE_ERROR
        | TestRateCardActionTypes.ADD_TEST_RATE_CARD
        | TestRateCardActionTypes.EDIT_TEST_RATE_CARD
        | TestRateCardActionTypes.GET_TEST_RATE_CARD
        | TestRateCardActionTypes.GET_TEST_RATE_CARDS
        | TestRateCardActionTypes.RESET
        | TestRateCardActionTypes.RESET_SUCCESS
        | TestRateCardActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const testRateCardApiResponseSuccess = (
    actionType: string,
    data: TestRateCardData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestRateCardActionType => ({
    type: TestRateCardActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const testRateCardApiResponseError = (
    actionType: string,
    data: TestRateCardData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestRateCardActionType => ({
    type: TestRateCardActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addTestRateCard = (params: any): TestRateCardActionType => ({
    type: TestRateCardActionTypes.ADD_TEST_RATE_CARD,
    payload: params,
});

export const editTestRateCard = (params: any): TestRateCardActionType => ({
    type: TestRateCardActionTypes.EDIT_TEST_RATE_CARD,
    payload: params,
});

export const GetTestRateCards = (params: any): TestRateCardActionType => ({
    type: TestRateCardActionTypes.GET_TEST_RATE_CARDS,
    payload: params,
});

export const GetTestRateCard = (params: any): TestRateCardActionType => ({
    type: TestRateCardActionTypes.GET_TEST_RATE_CARD,
    payload: params,
});

export const resetTestRateCard = (): TestRateCardActionType => ({
    type: TestRateCardActionTypes.RESET,
    payload: {},
});

export const resetTestRateCardSuccess = (): TestRateCardActionType => ({
    type: TestRateCardActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetTestRateCardError = (): TestRateCardActionType => ({
    type: TestRateCardActionTypes.RESET_ERROR,
    payload: {},
});
